import React from 'react';
import { Link } from 'react-router-dom';
import { TrialStatus } from '../../types/billing';

interface TrialBannerProps {
  trialStatus: TrialStatus;
}

const TrialBanner: React.FC<TrialBannerProps> = ({ trialStatus }) => {
  if (!trialStatus.isActive && !trialStatus.hasExpired) return null;

  return (
    <div
      className="w-full px-4 py-3 flex items-center justify-center gap-2 text-sm text-white"
      style={{ backgroundColor: '#374151' }}
      role="banner"
      aria-live="polite"
    >
      <span className="font-medium">
        {trialStatus.hasExpired
          ? 'Your free trial has expired.'
          : `Your free trial ends in ${trialStatus.daysRemaining} day${trialStatus.daysRemaining === 1 ? '' : 's'}.`}
      </span>
      <Link
        to="/pricing"
        className="ml-2 inline-flex items-center rounded-md bg-white px-3 py-1 text-sm font-semibold text-gray-700 hover:bg-gray-100 transition-colors"
      >
        Upgrade Now
      </Link>
    </div>
  );
};

export default TrialBanner;
